export type SearchItem = {
  id?: string | number
  label: string
  subtitle?: string
  url?: string
  action?: string
  type?: 'text' | 'link' | 'button' | 'nested'
  popover_id?: string
  [key: string]: unknown
}

export type SearchPage = {
  items: SearchItem[]
  nextPage: boolean
}

export type SearchResult =
  | { status: 'ok'; page: SearchPage }
  | { status: 'error'; error: unknown }

const decode = (payload: unknown): SearchPage => {
  const body = (payload ?? {}) as { items?: SearchItem[]; resources?: { id: string | number; name: string }[]; next_page?: boolean }
  const items = body.items ?? (body.resources ?? []).map(resource => ({ id: resource.id, label: resource.name }))

  return { items, nextPage: Boolean(body.next_page) }
}

export const searchQueryUrl = (searchUrl: string, query: string, page: number): string => {
  const url = new URL(searchUrl, window.location.origin)

  url.searchParams.set('query', query)
  url.searchParams.set('page', String(page))

  return url.toString()
}

export async function fetchSearchPage(searchUrl: string): Promise<SearchResult> {
  try {
    const response = await fetch(searchUrl, { headers: { Accept: 'application/json' } })

    if (!response.ok) return { status: 'error', error: new Error(`search request failed: ${response.status}`) }

    return { status: 'ok', page: decode(await response.json()) }
  } catch (error) {
    return { status: 'error', error }
  }
}
